import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommonService } from "../../../shared/common.service";
import { AuthServiceLocal } from "../../auth.service";
import { Router } from "@angular/router";
import { HttpResponse } from "@angular/common/http";
import { StreamService } from "../../../shared/stream.service";
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm: FormGroup;
  formSubmitted: boolean = false;
  isLoading: boolean = false;
  show: boolean = false;
  isLogin: boolean = true;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  constructor(
    private fb: FormBuilder,
    private authServices: AuthServiceLocal,
    private commonService: CommonService,
    private streamService: StreamService,
    private router: Router,
    private _snackBar: MatSnackBar,) { 
     
    }

  ngOnInit() {
    this.initialiseForms();

  }


 

  initialiseForms() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required, Validators.minLength(6)]],
    });

  }

  login() {
    this.formSubmitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    const email = (this.loginForm.controls["email"].value || "").trim();
    const password = (this.loginForm.controls["password"].value || "").trim();
    const req = {
      email,
      password,
    };
    this.isLoading = true;
    this.authServices.validateLogin(req).subscribe(
      (res: HttpResponse<any>) => {
        this.isLoading = false;
        const body = res?.body || {};

        if (body && body["success"]) {
          let decodedUser: any = null;
          if (body['data']["token"]) {
            this.commonService.setStorage("token", body['data']["token"]);
            try {
              decodedUser = this.commonService.getUser();
            } catch (error) {
              decodedUser = null;
            }
          }

          const user = body['data']["user"] || null;
          const role = user?.roles || decodedUser?.roles || decodedUser?.userType;

          if (user) {
            localStorage.setItem("userData", JSON.stringify(user));
          }
        
          if (role === 'superadmin' || role === 'admin') {
            localStorage.setItem("role", role);
            localStorage.setItem("activeIndex", "0");
            this.router.navigate(["/dashboard"]);
            this.sendRouteVal(0);
          } else {
            this.commonService.removeStorage("token");
            localStorage.removeItem("userData");
            localStorage.removeItem("role");
            this._snackBar.open("You don't have access to this portal.", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["failure"],
            });
            return;
          }
        } else {
          const errorMessage = body?.message || 'Unable to process login.';
          this._snackBar.open(errorMessage, "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["failure"],
          });
        }
      },
      err => {
        this.isLoading = false;
        const backendMsg = err?.error?.message || err?.error?.data || 'Login failed.';
        this._snackBar.open(backendMsg, "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["failure"],
        });
      }
    );
  }

  sendRouteVal(index) {
    this.streamService.streamMessage(index)
    // this.messageEvent.emit(index);
  }
  password() {
    this.show = !this.show;
  }

}
